import React, { Component } from 'react';
import { Button, Card, CardBody, CardHeader, CardSubtitle, CardText, ListGroup, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import ReportListItem from 'components/ReportListItem';
import Pagination from 'react-js-pagination';
import ReportCard from 'components/ReportCard';
import IntlMessages from 'util/IntlMessages';

class ReportList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 'list',
			activePage: 1
		};
	}
	render() {
		const reports = this.props.reports.slice(0 + (this.state.activePage - 1) * 10, 10 + (this.state.activePage - 1) * 10);
		const settings = this.props.settings;

		return (
			<Card className="border-0">
				<CardHeader className="custom-main">
					<IntlMessages id="meldooWeb.reportCollection.title" />
				</CardHeader>
				<CardBody>
					<div className="w-100 d-flex justify-content-center mb-4">
						<Nav className="nav-pill-sales">
							<NavItem>
								<NavLink
									className={this.state.activeTab === 'list' ? 'custom-accent' : ''}
									onClick={() => {
										this.setState({ activeTab: 'list' });
									}}
								>
									<i className="zmdi zmdi-view-list zmdi-hc-lg" />
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink
									className={this.state.activeTab === 'cards' ? 'custom-accent' : ''}
									onClick={() => {
										this.setState({ activeTab: 'cards' });
									}}
								>
									<i className="zmdi zmdi-view-module zmdi-hc-lg" />
								</NavLink>
							</NavItem>
						</Nav>
					</div>
					<TabContent activeTab={this.state.activeTab}>
						<TabPane tabId="list">
							<ul className="list-unstyled">
								{reports.map((report, index) => (
									<ReportListItem
										key={index}
										data={report}
										shortenText={true}
										toReport={this.props.toReport}
										modules={settings.modules}
									/>
								))}
								{reports.length === 0 && <li style={{ textAlign: 'center' }}>Keine Meldungen vorhanden</li>}
							</ul>
						</TabPane>

						<TabPane tabId="cards">
							<div className="row">
								{reports.map((report, index) => (
									<div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12" key={index}>
										<ReportCard data={report} shortenText={true} toReport={this.props.toReport} modules={settings.modules} />
									</div>
								))}
							</div>
						</TabPane>
					</TabContent>
					<Pagination
						activePage={this.state.activePage}
						itemsCountPerPage={10}
						totalItemsCount={this.props.reports.length}
						pageRangeDisplayed={5}
						onChange={activePage => this.setState({ activePage })}
						innerClass="pagination justify-content-center my-3 my-sm-5"
						itemClass="page-item"
						linkClass="page-link"
						activeLinkClass="custom-accent"
					/>
				</CardBody>
			</Card>
		);
	}
}

export default ReportList;



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/ReportCollection/Component/ReportList.js